export const TranslatedStrings = {
	is: {
		home: {
			title: 'Stofnaðu sparnaðarreikning hjá Auði með góðum innlánsvöxtum',
			mainContent: {
				linkText: 'Sækja appið',
			},
			helloContent: {
				headline: (
					<h1>
						Halló ég er <em>Auður.</em> Þægileg leið í sparnaði.
					</h1>
				),
				subheadline: 'Ég býð hæstu mögulegu vexti án binditíma. Vertu með! Það tekur bara 3 mínútur.',
				linkText: 'Nánar',
			},
		},
		calculatorStrings: {
			title: 'Reikna áætlaða ávöxtun',
			clear: 'Hreinsa',
			originalBalance: 'Upphafsstaða',
			monthlyDeposit: 'Mánaðarleg innborgun',
			time: 'Tími',
			months: 'mánuðir',
			savingsTabTitle: 'Óbundinn',
			termTabTitle: 'Bundinn',
			futureTabTitle: 'Framtíðar',
			companyTabTitle: 'Fyrirtækjareikningur',
			month: 'mánuður',
			interest: 'Vextir',
			interestRoute: 'Vaxtaleið',
			projectedEarnings: 'Áætluð innstæða í lok tímabils',
			projectedInterests: 'Áætlaðar vaxtatekjur á tímabili',
			audurInterestRate: 'Vextir hjá Auði',
			termSelectionText: 'Vaxtaprósenta og binditími',
			marketInterestRate: 'Meðalvextir á markaði',
			projectedYearlyInflation: 'Áætluð verðbólga á ársgrundvelli',
		},
		navigationStrings: {
			savings: 'Sparnaður',
			faq: 'Algengar spurningar',
			about: 'Um Auði',
			app: 'Appið',
			createAccount: 'Stofna reikning',
			login: 'Innskráning',
			contactUs: 'Hafðu samband',
		},
		cookieConsentStrings: {
			cookieConsentTitle:
				'Vefur Auðar notar vefkökur til þessa að safna upplýsingum um umferð á vefnum, til að bæta upplifun og vegna auglýsingabirtinga.',
			moreOnCookies: 'Nánar um vefkökunotkun',
			cookieSettings: 'Stillingar',
			agreeCookiePolicy: 'Samþykkja',
			readMore: 'Lesa meira',
			weUseCookies: 'Við notum vefkökur',
		},
		cookieSettingsStrings: {
			defaultCookieSettingsTitle: 'Nauðsynlegar vefkökur',
			defaultCookieSettingsInfo:
				'Sumar vefkökur eru nauðsynlegar til að vefsvæðið virki eðlilega og eru þær sjálfkrafa virkar',
			statisticsCookieSettingsTitle: 'Tölfræði',
			statisticsCookieSettingsInfo:
				'Tölfræðilegar vefkökur hjálpa okkur að bæta heildarupplifun gesta á vefsvæðinu með því að safna upplýsingum um notkun.',
			allowStatisticsCookie: 'Leyfa tölfræðilegar vefkökur',
			marketingCookieSettingsTitle: 'Markaðssetning',
			marketingCookieSettingsInfo:
				'Vefkökur fyrir markaðssetningu eru notaðar til að safna upplýsingum um hegðun notanda til að geta birt viðeigandi auglýsingar.',
			allowMarketingCookie: 'Leyfa vefkökur fyrir markaðssetningu',
			saveSettings: 'Vista stillingar',
			cookieSettings: 'Stillingar vefkaka',
		},
		footerStrings: {
			trademarkString: 'Auður er vörumerki Kviku banka hf.',
			furtherInfo: 'Nánari upplýsingar eru á kvika.is',
			startSaving: 'Byrjaðu að spara',
		},
		menuStrings: {
			legalNotice: 'Lagalegir fyrirvarar',
			cookieTerms: 'Vefkökuskilmálar',
			businessTerms: 'Viðskiptaskilmálar Auðar',
			termAccountTerms: 'Skilmálar bundins reiknings',
			appTerms: 'App skilmálar',
			futureAccountTerms: 'Skilmálar græns framtíðarreiknings',
			privacyPolicy: 'Persónuverndarstefna',
			termsAndPrivacyPolicy: 'Skilmálar og persónuverndarstefna',
			metaTags: {
				title: 'Skilmálar',
				description: 'Auður er fjármálaþjónusta á netinu',
				imageUrl:
					'https://images.prismic.io/audur/ed8073b4-49f0-447d-b4bf-03e0b5fa75b5_audur_meta_tag.png?auto=compress,format',
			},
		},
		contact: {
			title: 'Hafa samband',
			contact: 'Hafa samband',
			subtitle: 'Hér getur þú sent okkur fyrirspurn eða hringt í síma 585 6500.',
			form: {
				name: 'Nafn',
				email: 'Netfang',
				message: 'Fyrirspurn',
			},
			send: 'Senda',
			nameError: 'Vinsamlegast fyllið inn nafn',
			emailError: 'Netfang er ekki gilt',
			messageError: 'Vinsamlegast fyllið inn fyrirspurn',
			metaTags: {
				title: 'Hafa samband',
				description: 'Auður - auðvelt - auðvitað!',
				imageUrl:
					'https://images.prismic.io/audur/ed8073b4-49f0-447d-b4bf-03e0b5fa75b5_audur_meta_tag.png?auto=compress,format',
			},
			toastSuccessGeneral: 'Fyrirsprun hefur verið send!',
			toastSuccessCompliance: 'Kvörtun hefur verið send!',
			toastErrorGeneral: 'Ekki tókst að senda fyrirspurn',
			toastErrorCompliance: 'Ekki tókst að senda kvörtun',
			homepage: 'Aftur á forsíðu',
			close: 'Loka',
			modalTitle: `Takk fyrir! Fyrirspurn þín hefur verið móttekin.`,
			modalDescription: 'Við munum hafa samband eins fljótt og hægt er.',
			failedModalTitle: 'Villa!',
			failedModalDescription:
				' Því miður kom upp villa þegar við reyndum að senda fyrirspurn þína. Vinsamlegast reyndu aftur síðar eða hafðu samband við okkur beint í gegnum audur@audur.is',
		},
		createAccount: {
			title: 'Stofnaðu reikning hjá Auði með góðum innlánsvöxtum',
			heading: 'Stofna reikning',
			startSaving: 'Byrjaðu að spara með Auði.',
			description:
				'Það tekur aðeins nokkrar mínútur að stofna reikning hjá Auði og ferlið er einfalt og þægilegt fyrir alla. Til þess að stofna reikning þarftu að vera með íslenska kennitölu, hafa náð 18 ára aldri og vera með skattalegt heimilisfesti á Íslandi.',
			step1: 'Auðkenndu þig með rafrænum skilríkjum',
			step2: 'Svaraðu nokkrum spurningum',
			step3: 'Leggðu sparnaðinn þinn inn',
			metaTags: {
				title: 'Vertu með!',
				description: 'Það tekur aðeins 3 mínútur að vera með',
				imageUrl:
					'https://images.prismic.io/audur/ed8073b4-49f0-447d-b4bf-03e0b5fa75b5_audur_meta_tag.png?auto=compress,format',
			},
		},
		faq: {
			title: 'Algengar spurningar um innlánsreikninga Auðar',
			heading: 'Algengar spurningar',
			savingsAccount: 'Sparnaðarreikningur',
			termDepositAccount: 'Bundinn reikningur',
			contact: 'Hafa samband',
		},
		Page404: {
			heading: '404',
			subHeading: 'Þessi síða er ekki til',
			linkText: 'Fara aftur heim',
		},
		Page500: {
			heading: 'Villa hefur komið upp',
			subHeading: 'Villa hefur komið upp á þessari síðu, vinsamlega reyndu aftur.',
			linkText: 'Fara aftur heim',
		},
		sopraStrings: {
			button: 'Nánar hér',
			heading:
				'Smá vesen, vegna tæknilegra örðugleika gætu sumar aðgerðir, t.d. innskráning, ekki virkað sem skyldi. Við erum að vinna í málinu.',
		},
		mortgagePage: {
			heroDefaultTitle: 'Húsnæðislán',
			heroDefaultDescription: 'Óverðtryggt lán með hagstæðari vöxtum og lægri greiðslubyrði.',
			heroDefaultButton: 'Sækja um húsnæðislán',
			heroDefaultCalculatorButton: 'Lánareiknivél',
			imageUrl:
				'https://images.prismic.io/audur/ed8073b4-49f0-447d-b4bf-03e0b5fa75b5_audur_meta_tag.png?auto=compress,format',

			twoPathsDefaultTitle: 'Tvær leiðir í átt að settu marki',
			twoPathsDefaultDescription:
				'Auður býður upp á tvær óverðtryggðar leiðir. Leiðirnar hentar sem vilja skjóta eignamyndun og hinsvegar þeim sem kjósa þægilegri greiðslubyrgði.',
			twoPathsFirstDefaultTitle: 'Hraðari eignamyndun',
			twoPathsFirstDefaultSubtitle: '9,95% vextir · Óverðtryggt',
			twoPathsFirstDefaultDescription: 'Allir vextir greiddir mánaðarlega og ekkert bætist við höfuðstól lánsins.',
			twoPathsFirstDefaultButton: 'Sjá nánar',
			twoPathsSecondDefaultTitle: 'Léttari greiðslubyrði',
			twoPathsSecondDefaultSubtitle: '10,25% vextir · Óverðtryggt',
			twoPathsSecondDefaultDescription: 'Vaxtagreiðslum frestað að hluta til að létta greiðslubyrðina tímabundið.',
			mortgageEquityTitle: 'Eignamyndun',
			mortgageEqualizationTitle: 'Greiðslujöfnunarleið',
			mortgagePricingTitle: 'Verðskrá',
			mortgageCBInterestRateTitle: 'Þróun vaxta',
		},
		newCalculator: {
			monthlyPayment: 'Mánaðargreiðsla',
			monthlyPaymentAfter3Years: 'Mánaðargreiðsla fyrstu XX árin',

			headerTitle: 'Reiknaðu hvaða leið hentar þér',
			monthlyInstallment: 'Áætluð þróun eignar í húsnæði',
			equalization: 'Hraðari eignamyndun',
			equalizationDescription: '% vextir · Óverðtryggt',
			equalizationSubDescription: 'Sjá nánar um lánaleið',
			reduction: 'Léttari greiðslubyrði',
			reductionDescription: '% vextir · Óverðtryggt',
			reductionSubDescription: 'Sjá nánar um lánaleið',
			loanTerm: 'Lánstími',
			interest: 'Vextir',
			interestTodayOption1: 'Óbreyttir út lánstímann',
			interestTodayOption2: 'Breyting eftir 3 ár',
			taxFreeAllocation: 'Reglulegar auka innborganir á höfuðstól',
			taxFreeAllocationLabel: 'Reglulegar auka innborganir á höfuðstól',
			interestRate: 'Vaxtaforsendur',
			paymentAgreements: 'Greiðslufyrirkomulag',
			paymentArrangementOptionEqualPayments: 'Jafnar greiðslur',
			paymentArrangementOptionEqualPrincipalPayments: 'Jafnar afborganir',
			totalPaid: 'Samtals greitt',
			ahk: 'Árleg hlutfallstala kostnaðar',
			expandPaymentPlan: 'Sjá greiðsluáætlun',
			minimum: 'Lágmark',
			maximum: 'Hámark',
			loanAmount: 'Upphæð láns',
			proprtyMarketValue: 'Markaðsvirði',
			estimatedPropertyAnnualIncrease: 'Áætluð ársbreyting á húsnæðisverði',
			estimatedPropertyAnnual10YearOption1: 'Meðaltal sl. 10 ár',
			estimatedPropertyAnnual10YearOption2: 'Meðaltal 2024',
			firstPayment: 'Fyrsta greiðsla',
			marketValueLoan: 'Eign í húsnæði',
			estimatedEquityAfterXYears: 'Áætluð eign í húsnæði eftir XX ár',
			estimatedEquityAfterXYearsShort: 'Áætluð eign eftir XX ár',
			rateOfEquity: 'Stilla eignamyndun',
			temporaryReduction: 'Stilla greiðslubyrði',
			durationOfReduction: 'Tímabil',
			paymentPlanTitle: 'Greiðsluáætlun hraðari eignamyndunar',
			paymentPlanTitleReduction: 'Greiðsluáætlun léttari greiðslubyrðar',

			deafultPropertyMarketValueTooltip:
				'Markaðsvirði húsnæðis. Getur verið kaupverð, fasteignamat eða verðmat frá löggildum fasteignasala.',
			defaultEstimatedPropertyAnnualIncreaseTooltip:
				'Til að átta sig á áhrifum af breytingum á húsnæðiverði og áhrif þess á eignamyndun í húsnæði er hér hægt að slá inn forsendur um ársbreytingar í prósentum.',
			defaultEqualizationTooltip: 'Áætlun með 9,95% óverðtryggðum vöxtum, hönnuð til að byggja upp eignamyndun.',
			defaultReductionTooltip: 'Áætlun með 10,25% óverðtryggðum vöxtum, hönnuð til að létta greiðslubyrði.',
			defaultPropertyEquityTooltip:
				'Eigið fé í húsnæði reiknast sjálfkrafa út skv. forsendum um markaðsvirði húsnæðis að frádreginni upphæð láns.',
			defaultMonthlyInstallmentTooltip: 'Áætluð greiðslubyrði á mánuði í upphafi lánstímans',
			defaultEstimatedEquityxYearsTooltip: 'Áætluð eignamyndun eftir XX ár miðað við núverandi markaðsaðstæður.',
			defaultRateOfEquityTooltip: 'Hlutfall eignar miðað við heildarvirði fasteignarinnar.',
			defaultTemporaryReductionTooltip:
				'Hér er hægt að stilla greiðslubyrðina í fastar lægri manaðargreiðslur í allt að 3 ár frá lántökudegi.',
			defaultTemporaryReductionLengthTooltip:
				'Hér hægt að velja lengd tímabils fastra og lægri mánaðargreiðsla, allt frá 1 ári til 3ja ára frá lántökudegi.',
			defaultDurationOfReductionTooltip: 'Tímalengd tímabundinnar greiðslulækkunar, mæld í árum.',
			defaultMonthlyInstallementChartTooltip: 'Myndrit sem sýnir þróun mánaðarlegra greiðslna yfir lánstímann.',
			defaultLoanTermTooltip:
				'Til að flýta fyrir eignamyndun í húsnæði er mælt með því að greiða höfuðstólinn hraðar niður t.d. með styttri lánstíma',
			defaultInterestTooltip:
				'Hér eru settir inn vextir lánsins sem eru breytilegir. Sjálfvalið gildi eru gildandi vextir eins og þeir eru á nýjum lánum í dag en hægt er að breyta því til að sjá áhrif þess á greiðslubyrði og heildarlántökukostnað við lánið.',
			defaultTax_freeAllocationTooltip:
				'Hér er hægt að setja inn mánaðarlegar aukagreiðslur, s.s. skattfrjálsa ráðstöfun séreignasparnaðar (nánari upplýsingar á vef skattsins)',
			defaultInterestRateTooltip: 'Árleg vaxtaprósenta sem gildir fyrir lánið.',
			defaultPaymentAgreementsTooltip:
				'Jafnar greiðslur gera það að verkum að afborganir af höfuðstól eru lægri í upphafi lánstímans til að vega upp á móti hærri vaxtagreiðslum í byrjun lánstímans.  Jafnar afborganir af höfuðstól flýta fyrir eignamyndun í húsnæði þar sem ávallt greiðist sama upphæðin inn á höfuðstólinn, greiðslubyrðin er því hærri í upphafi lánstímans en lækkar svo með lækkandi höfuðstól.',
			defaultTotalPaidTooltip: 'Heildarupphæð sem hefur verið greidd yfir lánstímann.',
			defaultAhkTooltip:
				'Mælir heildarkostnað við lántöku. Lýsir heildarlántökukostnaði sem árlegum hundraðshluta af heildarfjárhæð láns.',
			defaultTotalCostTooltip: 'Heildarkostnaður lánsins, þ.m.t. vexti og gjöld.',
			defaultLoanAmountMinusCostsTooltip: 'Heildarupphæð lánsins að frádregnum kostnaði.',
			defaultTemporaryReductionInfoTooltip: 'Tímabundin lækkun á greiðslum, oftast í byrjun lánstímans.',
			defaultBorrowingCostTooltip: 'Lántökukostnaður fylgir verðskrá Auðar hverju sinni.',

			defaultInterestOption1Tooltip:
				'Sjálfvalið eru gildandi vextir eins og þeir eru á nýju lánunum í dag en hægt að breyta þeim til að sjá áhrifin á greiðslubyrði og heildarkostnað lánsins',
			defaultInterestOption2Tooltip:
				'Skilmálar lána kveða á um hækkun á vaxtaálagi að þremur árum liðnum (https://audur.is/husnaedislan/throun-vaxta) og hér er hægt að sjá áhrif þess á greiðslubyrði og heildarkostnað lánsins',

			annualPercentageCost: 'Árleg hlutfallstala kostnaðar',
			borrowingCost: 'Lántökukostnaður',
			borrowingFee: 'Lántökugjald',
			registrationFee: 'Þinglýsingargjald',
			documentFee: 'Skjalagerðargjald',
			paymentAssessmentFee: 'Greiðslumatsgjald',
			totalCost: 'Heildarkostnaður',
			loanAmountMinusCosts: 'Útborguð fjárhæð að frádregnum kostnaði',

			totalPaidHeaderFaster: 'Samtals greitt eftir XX ár',
			totalPaidLabelFaster: 'Greiðsluáætlun hraðari eignamyndunar',

			totalPaidHeaderLighter: 'Samtals greitt eftir XX ár',
			totalPaidLabelLighter: 'Greiðsluáætlun léttari greiðslubyrðar',
			temporaryReductionInfo: 'Greiðslufyrirkomulag léttari greiðslubyrðar er ávallt jafnar greiðslur',
			showLess: 'Sýna færri kostnaðarliði',
			selectPaymentReductionPlan: 'Velja léttari greiðslubyrði',
			selectAssetFormationPlan: 'Velja hraðari eignamyndun',
			showMore: 'Sjá alla kostnaðarliði',
			forward: 'Áfram',
			hideSettings: 'Fela stillingar',
			showSettings: 'Sýna stillingar',
			showPaymentPlan: 'Sjá greiðsluáætlun',
		},
	},
}
